var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmvGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.5015L5.5 8.50146L8.2 11.3015L12.5 6.00146",
    stroke: "#9296AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2558 14L2.41135 14.085L2.41918 2.00244",
    stroke: "#9296AC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.47162L5.50001 5.47314L8.49994 6.47159L12.4999 9.47305",
    stroke: "#9296AC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.47162,
    r: 1,
    fill: "white",
    stroke: "#9296AC",
    strokeWidth: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.3999,
    cy: 8.59998,
    r: 1,
    fill: "white",
    stroke: "#9296AC",
    strokeWidth: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.19995,
    cy: 11.2002,
    r: 1,
    fill: "white",
    stroke: "#9296AC",
    strokeWidth: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.6001,
    cy: 6.57172,
    r: 1,
    fill: "white",
    stroke: "#9296AC",
    strokeWidth: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 9.47162,
    r: 1,
    fill: "white",
    stroke: "#9296AC",
    strokeWidth: 0.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 6,
    r: 1,
    fill: "white",
    stroke: "#9296AC",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmvGray);
export default __webpack_public_path__ + "static/media/cmvGray.8c5734135ea24ceeccaa8365155c64bd.svg";
export { ForwardRef as ReactComponent };